import { Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { DriverTravelList } from './driverTravellist.view';

export const DriverTravelListRouter = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <DriverTravelList />
        </Route>
      </Switch>
    </div>
  );
};
